import { Serializable } from '@/models/core/serializable';

export class InterviewNaviCompetency implements Serializable<InterviewNaviCompetency> {
  competencyID: number;
  upComment: string;
  downComment: string;

  deserialize(input: any) {
    this.competencyID = input.competencyID;
    this.upComment = input.upComment;
    this.downComment = input.downComment;
    return this;
  }
}
